define('home/views/SettingsAccountFormView',[
    'underscore',

    'core/mixins/withEmailVerifyLink',

    'home/templates/settingsAccountForm',
    'home/views/common/BaseSettingsView',
], function (
    _,

    withEmailVerifyLink,

    settingsAccountFormTemplate,
    BaseSettingsView
) {
    'use strict';

    var SettingsAccountFormView = BaseSettingsView.extend({
        template: settingsAccountFormTemplate,

        events: _.defaults({
            'keyup input[name=username]': 'handleKeyup',
        }, BaseSettingsView.prototype.events),

        onRender: function () {
            this.$usernamePlaceholder = this.$('[data-role=username-placeholder]');
            BaseSettingsView.prototype.onRender.apply(this, arguments);
        },

        handleKeyup: _.debounce(function (ev) {
            this.$usernamePlaceholder.text(ev.currentTarget.value || this.model.get('username'));
        }, 300),

    });

    withEmailVerifyLink.call(SettingsAccountFormView.prototype);

    return SettingsAccountFormView;
});

